/**
 * Shared upload type enum.
 * Used by upload configs, UploadDataForm, and VerificationResultModal
 * to consistently identify the upload type for display and verification logic.
 */
export const UPLOAD_TYPE = Object.freeze({
	DAILY_SOLAR: "Daily Solar ON/OFF Modification Upload",
	IRRADIANCE: "Irradiance Range Upload",
	INDEXES: "Monthly Indexes Upload",
	REINSERT: "Daily Data Reinsertion Upload",
});
